import $ from 'jquery';
import 'jquery-mask-plugin';
import hyperform from 'hyperform/dist/hyperform.cjs';

const cellphoneMaskBehavior = function cellphoneMaskBehavior(val) {
  return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
};

const cellPhoneOptions = {
  onKeyPress(...args) {
    args[2].mask(cellphoneMaskBehavior.apply({}, args), args[3]);
  },
};

export default {
  init() {
    this.decorateFields();
    this.applyLanguage();
    this.applyMasks();
    this.applyValidator();
    this.submitForm();
  },
  submitForm() {
    const page = $(document);
    const loader = $('.ajax-loader');

    page.on('click', '.wpcf7-submit', (e) => {
      if (loader.hasClass('is-active')) {
        e.preventDefault();
      }
    });
  },
  decorateFields() {
    const elms = document.querySelectorAll('input, select, textarea');

    for (let i = 0, j = elms.length; i < j; i += 1) {
      elms[i].addEventListener('invalid', (event) => {
        $(event.currentTarget).parents('.form__field').first().addClass('form__field--error');
      });

      elms[i].addEventListener('valid', (event) => {
        $(event.currentTarget).parents('.form__field').first().removeClass('form__field--error');
      });
    }
  },
  applyLanguage() {
    hyperform.add_translation('pt-br', {
      TextTooLong: 'Please shorten this text to %l characters or less (you are currently using %l characters).',
      ValueMissing: 'Por favor, preencha esse campo.',
      CheckboxMissing: 'Please check this box if you want to proceed.',
      RadioMissing: 'Please select one of these options.',
      FileMissing: 'Please select a file.',
      SelectMissing: 'Por favor, escolha uma opção.',
      InvalidEmail: 'Por favor, informe um e-mail válido.',
      InvalidURL: 'Please enter a URL.',
      PatternMismatch: 'Please match the requested format.',
      PatternMismatchWithTitle: 'Please match the requested format: %l.',
      NumberRangeOverflow: 'Please select a value that is no more than %l.',
      DateRangeOverflow: 'Please select a value that is no later than %l.',
      TimeRangeOverflow: 'Please select a value that is no later than %l.',
      NumberRangeUnderflow: 'Please select a value that is no less than %l.',
      DateRangeUnderflow: 'Please select a value that is no earlier than %l.',
      TimeRangeUnderflow: 'Please select a value that is no earlier than %l.',
      StepMismatch: 'Please select a valid value. The two nearest valid values are %l and %l.',
      StepMismatchOneValue: 'Please select a valid value. The nearest valid value is %l.',
      BadInputNumber: 'Please enter a number.',
    });

    hyperform.set_language('pt-br');
  },
  applyMasks() {
    $('.cpf').mask('000.000.000-00');
    $('.cnpj').mask('00.000.000/0000-00');
    $('.date').mask('00/00/0000');
    $('.cep').mask('00000-000');
    $('.phone').mask(cellphoneMaskBehavior, cellPhoneOptions);
  },
  applyValidator() {
    hyperform(window, {
      classes: {
        warning: 'form__error-message',
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Form.js